import { request } from "../../apiService";
import { AdminStatsQueryFilters, buildAdminStatsQueryInput } from "./statsQuery";

export type CalendarStatsResponse = {
    date: string;
    totalTrades: number;
}[];

export type CountersStatsResponse = {
    totalTrades: number;
    totalPayouts: number;
    /** En cours de formation, hors promo « AVANT OCTOBRE 2025 ». */
    activeMembers: number;
    trainedMembersCount: number;
    averageDayWinPercentage: number;
    dayTradingUsersCount: number;
    scalpingUsersCount: number;
};

export type DashboardStatsResponse = {
    counters: CountersStatsResponse;
    calendar: CalendarStatsResponse;
};

export const getDashboardStats = async (
    startDate: string,
    endDate: string,
    calendarStartDate: string,
    calendarEndDate: string,
    filters: AdminStatsQueryFilters = {}
) => {
    const input = {
        ...buildAdminStatsQueryInput(startDate, endDate, filters),
        calendarStartDate,
        calendarEndDate,
    };

    return request<DashboardStatsResponse, typeof input>(
        `/v3/admin/stats/dashboard?`,
        { input }
    );
};
